<template>
    <div class="main feed__container admin__container">
        <router-link class="back__link flex"
            to="/main"
        >
           <Back></Back><span>Powrót</span>
        </router-link>
        <Upload></Upload>
        <Download></Download>
        <Users></Users>

    </div>
</template>

<script>
import Back from '@/assets/img/arrow-left-solid.svg'

import Users from '@/components/Admin/BaseUsersAdmin'
import Upload from '@/components/Admin/BaseUpload'
import Download from '@/components/Admin/BaseDownload'

export default {
    components: {
        Back,
        Users,
        Upload,
        Download
    },
    data(){
        return {
            fileName: '',
            payload:'',
            title: '',
            tags:'',
            filePublic: true,
            color: '#000',
            file: {},
            fileSrc:''
        }
    },
    mounted(){
        this.$store.dispatch('message', '');
        this.$store.dispatch('pageType', null);
    },
    unmounted(){
        const payload = {
            page: null,
            year: true
        }
        this.$store.dispatch('resetState', payload);
        this.$store.dispatch('loadPosts');
    }
}
</script>
